import React, { useEffect, useState } from 'react';
import {
    loadData as loadDataActiveSelection,
    updateSmartly
} from "../../store/slice/model/ProductListingFilterBoxActiveSelection";
import { loadData } from "../../store/slice/model/ProductListingFilterBoxSelection";
import { useDispatch } from "react-redux";
import { useProductStore } from "../../hooks/product";
import { useProductFilterStore } from 'src/hooks/productFilter';

const FilterSelectionPopup = (props) => {
    const { SetStatus } = props
    const dispatch = useDispatch()
    const [listOfLI, SetListOfLI] = useState({});
    const [{ }, { }, { }, { optionsAvailable }] = useProductStore();
    const [optionsSearchInput, setOptionsSearchInput] = useState(false);
    const [{ filterBoxSelection, filterBoxActiveSelection }, {}, {}]= useProductFilterStore()

    useEffect(() => {
        SetListOfLI(optionsAvailable());
        applyMainThreadToActiveSelection();
    }, [])

    useEffect(() => {
        filterListOfLI(optionsSearchInput)
    }, [optionsSearchInput]);

    const setFilterBoxForField = (selectionOptionFromAvailable, selectionStatus) => {
        dispatch(updateSmartly({
            selection: selectionOptionFromAvailable,
            status: selectionStatus,
        }));
    }
    const getStatusOfFilterBoxForFieldApplied = (selectionOptionFromAvailable) => {
        return !!filterBoxActiveSelection[selectionOptionFromAvailable.slug];
    };
    const toggleAllSelection = () => {
        let status = !getMainSelectionStatus();
        Object.entries(listOfLI).map((v, i) => {
            if (!status) {
                setFilterBoxForField(listOfLI[v[0]], false)
            }
            if (status) {
                setFilterBoxForField(listOfLI[v[0]], true)
            }
        })
    }
    const filterListOfLI = (param) => {
        let here = optionsAvailable();
        Object.entries(optionsAvailable()).filter((v, i) => {
            if (param &&
                !v[1].main_label.toLowerCase().includes(param.toLowerCase())) {
                delete here[v[1].slug];
            }
        });
        SetListOfLI(here)
    }
    const getMainSelectionStatus = () => {
        if (Object.entries(filterBoxActiveSelection).length &&
            (Object.entries(filterBoxActiveSelection).length - 3) === Object.entries(listOfLI).length) {
            return true;
        }
        return false;
    }
    const applyToMainThread = () => {
        dispatch(loadData({ data: filterBoxActiveSelection }));
        SetStatus(false)
    }
    const applyMainThreadToActiveSelection = () => {
        dispatch(loadDataActiveSelection({ data: filterBoxSelection }));
    }

    return (
        <>
            <div className="avnet-modal modal-630">
                <div className="avnet-modal-inner">
                    <button type="button" className="close py-3" data-dismiss="modal"
                        onClick={() => {
                            SetStatus(false)
                        }}>×
                    </button>
                    {/* Modal Header */}
                    <div className="modal-header justify-content-center">
                        <h1 className="pcn-modal-heading">Add/Remove Filters</h1>
                    </div>
                    {/* Modal body */}
                    <div className="modal-body">
                        <div className="light-card m-b-10">
                            <div className="light-card-header dark-card-title">
                                <div className="light-card-title">
                                    <div className="form-check">
                                        <input type="checkbox" className="form-check-input font-16"
                                            checked={getMainSelectionStatus()}
                                            onChange={() => {
                                                toggleAllSelection()
                                            }}
                                            id="Column_Filter"
                                            name="Column_Filter" />
                                        <label className="form-check-label ps-0"
                                            htmlFor="Column_Filter">Column/Filter</label>
                                    </div>
                                </div>
                                <div className="light-card-search ms-auto">
                                    <div className="form-group has-search mb-0">
                                        <span className="fa fa-search text-black-stone form-control-feedback" />
                                        <input type="text" className="form-control mb-0"
                                            onChange={(e) => {
                                                setOptionsSearchInput(e.target.value)
                                            }}
                                            placeholder="Search" />
                                    </div>
                                </div>
                            </div>
                            <div className="light-card-body p-0">
                                <div className="filter-checkbox-list">
                                    {Object.entries(listOfLI).map((v, i) => (
                                        <React.Fragment key={i}>
                                            <div className="form-check my-0">
                                                <input type="checkbox" className="form-check-input font-16 my-0"
                                                    id={i + 'Row_Filter'}
                                                    checked={getStatusOfFilterBoxForFieldApplied(listOfLI[v[0]])}
                                                    onChange={(e) => {
                                                        setFilterBoxForField(listOfLI[v[0]], e.target.checked)
                                                    }}
                                                />
                                                <label className="form-check-label my-0"
                                                    htmlFor={i + 'Row_Filter'}>{listOfLI[v[0]].main_label}</label>
                                            </div>
                                        </React.Fragment>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* Modal footer */}
                    <div className="modal-footer text-center">
                        <div className="modal-footer-actions">
                            <button type="button" className="bs5 btn btn-secondary minw-auto"
                                onClick={() => {
                                    SetStatus(false)
                                }}>
                                Close
                            </button>
                            <button type="button" className="bs5 bs5 btn btn-primary minw-auto"
                                onClick={() => {
                                    applyToMainThread()
                                }}
                                data-toggle="modal"
                                data-target="#myModal">
                                Done
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default FilterSelectionPopup;